import { TResDataListApi } from '@src/configs/interface.config'
import { TAccount, TPatchAccount, TPostAccount, TQueryAccount } from '@src/modules'

import { request } from './config'

export const getListAccount = (params: TQueryAccount, token: string) =>
  request({ url: 'account', method: 'GET', params }, { token })
export const getAccountById = (id: string, token: string) => request({ url: `account/${id}`, method: 'GET' }, { token })
export const postAccount = (data: TPostAccount) => request({ url: 'account', method: 'POST', data })
export const patchAccountById = (id: string, data: TPatchAccount) =>
  request({ url: `account/${id}`, method: 'PATCH', data })
export const removeAccountById = (id: string) => request({ url: `account/${id}`, method: 'DELETE' })
export const removeManyAccountByIds = (ids: string[]) =>
  request({ url: `account/delete-many`, method: 'POST', data: { ids } })
export const importAccount = (data: FormData, token: string): Promise<TResDataListApi<TAccount[]>> =>
  request(
    {
      url: `account/import`,
      method: 'POST',
      data,
      headers: {
        Accept: 'application/xml, text/plain, text/html, *.*',
        'Content-Type': 'multipart/form-data, application/x-www-form-urlencoded;charset=utf-8',
      },
      transformRequest: [() => data],
    },
    { token },
  )

export const exportListAccount = (params: TQueryAccount, token: string) =>
  request(
    {
      url: 'account/export-xlsx',
      method: 'GET',
      params,
      headers: {
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
      responseType: 'blob',
    },
    { token },
  )
